import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1701115461239,
      object: 'counselors',
      success: true,
      interval: '01:00',
      days: [
        {
          date: '2025-10-18T13:30:00.000Z',
          slots: [
            {
              id: '2025-10-18-16-30',
              startTime: '2025-10-18T13:00:00.000Z',
              endTime: '2025-10-18T14:00:00.000Z',
              isAvailable: true,
            },
            {
              id: '2025-10-18-16-30',
              startTime: '2025-10-18T14:00:00.000Z',
              endTime: '2025-10-18T15:00:00.000Z',
              isAvailable: false,
            },
            {
              id: '2025-10-18-16-30',
              startTime: '2025-10-18T17:00:00.000Z',
              endTime: '2025-10-18T18:00:00.000Z',
              isAvailable: true,
            },
          ],
        },
        {
          date: '2025-10-19T13:30:00.000Z',
          slots: [
            {
              id: '2025-10-19-16-30',
              startTime: '2025-10-19T13:00:00.000Z',
              endTime: '2025-10-19T14:00:00.000Z',
              isAvailable: false,
            },
            {
              id: '2025-10-19-16-30',
              startTime: '2025-10-19T14:00:00.000Z',
              endTime: '2025-10-19T15:00:00.000Z',
              isAvailable: false,
            },
            {
              id: '2025-10-19-16-30',
              startTime: '2025-10-19T15:00:00.000Z',
              endTime: '2025-10-19T16:00:00.000Z',
              isAvailable: false,
            },
          ],
        },
      ],
    },
    status: 200,
  },

  error: {
    response: {
      createdAt: 1701115461239,
      object: 'counselors',
      success: false,
      interval: null,
      slots: [],
    },
    status: 500,
  },
};

const slotsHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  slotsHandler,
};
